module.exports = __webpack_public_path__ + "78cdb11067c960ead4f7f7ad2ff85ff7.pdf";